module.exports = __webpack_public_path__ + "img/走る.ad57c0b0.jpeg";